import styled from "styled-components";
import React from "react";
import { UserMobile } from "../../assets/User/UserMobile";

const StyleCss = styled.div`
  
`;

function ChangeMobile(props) {
  return (
    <StyleCss className="main-box">
      <div className="title-bar">
          <div className="title">
          <div className="icon"><UserMobile/></div>
          <div className="text">تغییر شماره همراه</div>
          </div>
      </div>
      <div className="content">
      </div>
    </StyleCss>
);
}
export default ChangeMobile;